import { IExpenseType, queryKeys } from '../../shared';
import { expenseTypeClient } from '../clients/expense-type.client';
import { useDelete, useSave } from '../../shared/hooks/new-base.hook';
import { useItem, UseItemParams, useList, UseListParams } from '../../shared/hooks/new-read-only.hook';

const client = expenseTypeClient;
const listKey = queryKeys.EXPENSE_TYPES;
const itemKey = queryKeys.EXPENSE_TYPE;

export function useExpenseTypesList(...args: UseListParams<IExpenseType>) {
    return useList(client, listKey, args);
}

export function useExpenseType(...args: UseItemParams<IExpenseType>) {
    return useItem(client, itemKey, args);
}

export function useSaveExpenseType() {
    return useSave(client, listKey, itemKey);
}

export function useDeleteExpenseType() {
    return useDelete(client, listKey);
}
